import { render, staticRenderFns } from "./BtPopup.vue?vue&type=template&id=297511e9&scoped=true&lang=pug"
import script from "./BtPopup.vue?vue&type=script&lang=js"
export * from "./BtPopup.vue?vue&type=script&lang=js"
import style0 from "./BtPopup.vue?vue&type=style&index=0&id=297511e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297511e9",
  null
  
)

export default component.exports